import { Component, Inject } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { Moment } from 'moment';

@Component({
    selector: 'app-custom-calendar-header',
    templateUrl: './custom-calendar-header.component.html',
    styleUrls: ['./custom-calendar-header.component.scss'],
    standalone: false
})
export class CustomCalendarHeaderComponent<D> {

  constructor(
    public calendar: MatCalendar<D>,
    private dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats
  ) {}

  get monthLabel(): string {
    const active = this.calendar.activeDate;
    const monthIdx = this.dateAdapter.getMonth(active); // 0-based
    return this.dateAdapter.getMonthNames('long')[monthIdx]; // e.g. "August"
  }

  get yearLabel(): string {
    return this.dateAdapter.getYearName(this.calendar.activeDate); // e.g. "2024"
  }

  previousClicked(): void {
    this.changeDate(-1);
  }

  nextClicked(): void {
    this.changeDate(1);
  }

  private changeDate(mult: number): void {
    switch (this.calendar.currentView) {
      case 'month':
        this.calendar.activeDate =
          this.dateAdapter.addCalendarMonths(this.calendar.activeDate, mult);
        break;
      case 'year':
        this.calendar.activeDate =
          this.dateAdapter.addCalendarYears(this.calendar.activeDate, mult);
        break;
      case 'multi-year':
        // same as Angular Material default: jump 24 years
        this.calendar.activeDate =
          this.dateAdapter.addCalendarYears(this.calendar.activeDate, mult * 24);
        break;
    }
  }

  // Click on the month text -> month selection view
  monthClicked(): void {
    this.calendar.currentView = 'year';
  }

  // Click on the year text -> multi-year (year range) view
  yearClicked(): void {
    this.calendar.currentView = 'multi-year';
  }
}
